// extracted by mini-css-extract-plugin
export default {"container":"ContactDetails_container__Ev9Wj","header":"ContactDetails_header__+6-Hx","text":"ContactDetails_text__3e-Cl"};